// Copyright (c) Codicent Inside AB. All rights reserved.
// This software and its associated documentation files (the "Software") are
// proprietary to Codicent Inside AB. Unauthorized copying of this file, via any
// medium is strictly prohibited. The Software is provided "AS IS", without
// warranty of any kind, express or implied, including but not limited to the
// warranties of merchantability, fitness for a particular purpose, and
// noninfringement. In no event shall the authors or copyright holders be liable
// for any claim, damages, or other liability, whether in an action of contract,
// tort, or otherwise, arising from, out of, or in connection with the Software
// or the use or other dealings in the Software.
 
import {
  CodicentAppState,
  getConfigValue,
  Button,
  Spinner,
  Text,
  Title,
} from "codicent-app-sdk";

import { makeStyles, tokens } from "@fluentui/react-components";
import { useState, useEffect } from "react";
import { Link } from "react-router";
// import { CodicentAppState } from "../hooks";
// import { Button, Spinner, Text, Title } from "../components";
// import { getConfigValue } from "../config";
 
const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    padding: "20px",
  },
  pricing: {
    padding: "20px",
    paddingLeft: "30px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    backgroundColor: tokens.colorNeutralBackground1,
  },
});
 
export const Purchase = ({ state }: { state: CodicentAppState }) => {
  const styles = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const { service, stateMachine } = state;
  const { updateContext } = stateMachine;
 
  useEffect(() => {
    // Handle return from Stripe
    const queryParams = new URLSearchParams(window.location.search);
    const sessionId = queryParams.get("session_id");
 
    if (sessionId) {
      // Handle successful payment here
      // You might want to validate the session with your backend
      // TODO: move the following to codicentservice
      updateContext({ hasValidPurchase: undefined }); // this will trigger a new check of subscription status
      // navigate("./", { replace: true }); // Navigate to root, replacing current history entry
      // service
      //   .checkSubscriptionStatus()
      //   .then((status) => {
      //     if (status === "active") {
      //       setPaid();
      //     }
      //   })
      //   .catch((error: unknown) => {
      //     console.error("Failed to check subscription status", error);
      //   });
    }
  }, []);
 
  const handlePurchase = async () => {
    try {
      setIsLoading(true);
      // Using the price ID for your subscription plan
      await service.redirectToCheckout(getConfigValue("STRIPE_PRICE_ID"));
    } catch (error) {
      console.error("Purchase error:", error);
      // You might want to show an error message to the user
    } finally {
      setIsLoading(false);
    }
  };
 
  return (
    <div className={styles.container}>
      <Title>Starta ditt abonnemang</Title>
      <div className={styles.pricing}>
        <ul>
          <li>
            <Text size={400}>Kreditkort krävs inte</Text>
          </li>
          <li>
            <Text size={400}>Gratis de 2 första månaderna</Text>
          </li>
          <li>
            <Text size={400}>Därefter 89 kr/månad</Text>
          </li>
        </ul>
      </div>
      <Button appearance="primary" onClick={handlePurchase} disabled={isLoading}>
        {isLoading ? <Spinner size="tiny" /> : "Starta abonnemang"}
      </Button>
      <div>
        {/* <Text size={400}>Genom att starta abonnemanget godkänner du våra villkor.</Text> */}
        {/* TODO: visa text som säger att om användaren har ett abonnemang redan, så kanske hen behöver logga ut och logga in med rätt konto...  */}
        <Text size={400}>
          Har du redan ett abonnemang? Kanske har du loggat in med fel konto. <Link to="/logout">Logga ut</Link> och
          sedan in igen för att komma igång.
        </Text>
      </div>
    </div>
  );
};
 
export default Purchase;